import { Component, EventEmitter, Output } from '@angular/core';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';

@Component({
  selector: 'app-busqueda-option',
  templateUrl: './busqueda-option.component.html',
  styleUrl: './busqueda-option.component.css'
})
export class BusquedaOptionComponent {

  @Output() valueChange = new EventEmitter<string>();
  value = '';
  placeholder = 'Buscar...';
  private debounce = 300;
  private subject = new Subject<string>();
  
  ngOnInit(){
    this.subject
      .pipe(
          debounceTime(this.debounce),
          distinctUntilChanged()
      )
      .subscribe(value => this.valueChange.emit(value));
  }

  onInput(event: Event){
    const value = (event.target as HTMLInputElement).value;
    this.subject.next(value);
  }

}
